import React from 'react'

function RightBlackIcon(props) {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M0 7.50044C0 3.35917 3.35897 0 7.49912 0C11.6401 0 15 3.35917 15 7.50044C15 11.6417 11.6401 15 7.49912 15C3.35897 15 0 11.6417 0 7.50044ZM5.98432 11.2154L6.00546 11.2339L12.3086 4.93042L11.1452 3.76607L5.98432 8.92901L3.8548 6.79584L2.69052 7.95931L5.96495 11.2339L5.98432 11.2154Z" fill="black" />
    </svg>
  )
}

export default RightBlackIcon
